import axios from "axios";

export const tokenAxiosInstance = axios.create();

export const setTokenAuthHeader = (token) => {
  tokenAxiosInstance.defaults.headers.common[
    "Authorization"
  ] = `Token ${token}`;
};
